import React, { createContext, useContext } from 'react';
import useGetUserData from '../hooks/useGetUserData';

const UserDataContext = createContext({
  userData: null,
  isLoading: false,
  fetchUserData: () => {},
});

export const useUserData = () => useContext(UserDataContext);

export const UserDataProvider = ({ isAuth, children }) => {
  const [userData, isLoading, fetchUserData] = useGetUserData(isAuth);
    
  return (
    <UserDataContext.Provider value={{ userData, isLoading, fetchUserData }}>
      {children}
    </UserDataContext.Provider>
  );
};
